import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSetRecoilState } from "recoil";
import { concateString } from "../common/interactiveCommon";
import KS2Address from "./KS2Address";
import KS2ContactInfo from "./KS2ContactInfo";
import KS2Contributions from "./KS2Contributions";
import KS2Email from "./KS2Email";
import KS2Footer from "./KS2Footer";
import KS2Header from "./KS2Header";
import KS2Intro from "./KS2Intro";
import KS2IRDNumber from "./KS2IRDNumber";
import KS2Name from "./KS2Name";
import KS2NameSalutation from "./KS2NameSalutation";
import KS2SectionAAlertInfo from "./KS2SectionAAlertInfo";
import KS2SeactionAHeader from "./KS2SectionAHeader";
import KS2SectionAKiwiSaver from "./KS2SectionAKiwiSaver";
import KS2SectionASuspensionSaving from "./KS2SectionASuspensionSaving";
import KS2Sign from "./KS2Sign";
import { cloneDeep } from "lodash";
import { errorState } from "../../../recoil/error/atom";
import validateDate from "../common/ValidationHelper";
import Button from "react-bootstrap/Button";
const KS2 = (props) => {
  const popError = useSetRecoilState(errorState);

  const NO_OF_NAME_COLUMN = 37;
  const NO_OF_STREET_NUMBER_COLUMN = 6;
  const NO_OF_STREET_ADDRESS_COLUMN = 24;
  const NO_OF_SUBURB_COLUMNS = 15;
  const NO_OF_POST_CODE_COLUMNS = 4;
  const NO_OF_PHONE_NO_COLUMNS = 9;
  const NO_OF_MOBILE_NO_COLUMNS = 11;
  const NO_OF_EMAIL_COLUMNS = 62;
  const [kiwiSaverMember, setKiwiSaverMember] = useState("");
  const [savingSuspension, setSavingSuspension] = useState("");
  const [iRDs, setIRDs] = useState(new Array(9).fill(""));
  const [nameTitleOther, setNameTitleOther] = useState(new Array(6).fill(""));
  const [selectedTitle, setSelectedTitle] = useState("");
  const [firstName, setFirstName] = useState(new Array(NO_OF_NAME_COLUMN).fill(""));
  const [surname, setSurname] = useState(new Array(NO_OF_NAME_COLUMN).fill(""));
  const [streetNumber, setStreetNumber] = useState(new Array(NO_OF_STREET_NUMBER_COLUMN).fill(""));
  const [streetAddress, setStreetAddress] = useState(new Array(NO_OF_STREET_ADDRESS_COLUMN).fill(""));
  const [subUrb, setSubUrb] = useState(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
  const [town, setTown] = useState(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
  const [postCode, setPostCode] = useState(new Array(NO_OF_POST_CODE_COLUMNS).fill(""));
  const [day, setDay] = useState(new Array(NO_OF_PHONE_NO_COLUMNS).fill("")); //Note: Here we are using day variable to be align with KS2 Pdf text.
  const [mobile, setMobile] = useState(new Array(NO_OF_MOBILE_NO_COLUMNS).fill(""));
  const [email, setEmail] = useState(new Array(NO_OF_EMAIL_COLUMNS).fill(""));
  const [contribution3, setContribution3] = useState("-");
  const [contribution4, setContribution4] = useState("");
  const [contribution6, setContribution6] = useState("");
  const [contribution8, setContribution8] = useState("");
  const [contribution10, setContribution10] = useState("");
  const [day1, setDay1] = useState("");
  const [day2, setDay2] = useState("");
  const [month1, setMonth1] = useState("");
  const [month2, setMonth2] = useState("");
  const [year3, setYear3] = useState("");
  const [year4, setYear4] = useState("");
  const [signature, setSignature] = useState("");

  const resetContribution = () => {
    setContribution3("");
    setContribution4("");
    setContribution6("");
    setContribution8("");
    setContribution10("");
  };

  const setSelectedTitleData = (title) => {
    setSelectedTitle(title);
  };

  const setKiwiSaverMemberOption = (kiwiSaverMember) => {
    setKiwiSaverMember(kiwiSaverMember);
  };

  const setSavingSuspensionOption = (savingSuspension) => {
    setSavingSuspension(savingSuspension);
  };

  const setIRDData = ({ name, value }) => {
    const index = parseInt(name.replace("IRD", ""), 10);
    let newCopyiRDs = cloneDeep(iRDs);
    newCopyiRDs[index - 1] = value;
    setIRDs(newCopyiRDs);
  };

  const clearOther = () => {
    setNameTitleOther(new Array(6).fill(""));
  };

  const setNameTitleOtherData = ({ name, value }) => {
    const index = parseInt(name.replace("nameTitleOther", ""), 10);
    let newCopyNameTitleOther = cloneDeep(nameTitleOther);
    newCopyNameTitleOther[index - 1] = value;
    setNameTitleOther(newCopyNameTitleOther);
  };

  const setName = ({ name, value }) => {
    if (name.indexOf("firstName") >= 0) {
      const index = parseInt(name.replace("firstName", ""), 10);
      let newCopyFirstName = cloneDeep(firstName);
      newCopyFirstName[index - 1] = value;
      setFirstName(newCopyFirstName);
    } else if (name.indexOf("surname") >= 0) {
      const index = parseInt(name.replace("surname", ""), 10);
      let newCopyLastName = cloneDeep(surname);
      newCopyLastName[index - 1] = value;
      setSurname(newCopyLastName);
    }
  };

  const setAdrress = ({ name, value }) => {
    if (name.indexOf("streetNumber") >= 0) {
      const index = parseInt(name.replace("streetNumber", ""), 10);
      let newCopyOfData = cloneDeep(streetNumber);
      newCopyOfData[index - 1] = value;
      setStreetNumber(newCopyOfData);
    } else if (name.indexOf("streetAddress") >= 0) {
      const index = parseInt(name.replace("streetAddress", ""), 10);
      let newCopyOfData = cloneDeep(streetAddress);
      newCopyOfData[index - 1] = value;
      setStreetAddress(newCopyOfData);
    } else if (name.indexOf("subUrb") >= 0) {
      const index = parseInt(name.replace("subUrb", ""), 10);
      let newCopyOfData = cloneDeep(subUrb);
      newCopyOfData[index - 1] = value;
      setSubUrb(newCopyOfData);
    } else if (name.indexOf("town") >= 0) {
      const index = parseInt(name.replace("town", ""), 10);
      let newCopyOfData = cloneDeep(town);
      newCopyOfData[index - 1] = value;
      setTown(newCopyOfData);
    } else if (name.indexOf("postCode") >= 0) {
      const index = parseInt(name.replace("postCode", ""), 10);
      let newCopyOfData = cloneDeep(postCode);
      newCopyOfData[index - 1] = value;
      setPostCode(newCopyOfData);
    }
  };

  const setContactNumber = ({ name, value }) => {
    if (name.indexOf("DAY") >= 0) {
      const index = parseInt(name.replace("DAY", ""), 10);
      let newCopyOfData = cloneDeep(day);
      newCopyOfData[index - 1] = value;
      setDay(newCopyOfData);
    } else if (name.indexOf("mobile") >= 0) {
      const index = parseInt(name.replace("mobile", ""), 10);
      let newCopyOfData = cloneDeep(mobile);
      newCopyOfData[index - 1] = value;
      setMobile(newCopyOfData);
    }
  };

  const setEmailData = ({ name, value }) => {
    if (name.indexOf("email") >= 0) {
      const index = parseInt(name.replace("email", ""), 10);
      let newCopyOfData = cloneDeep(email);
      newCopyOfData[index - 1] = value;
      setEmail(newCopyOfData);
    }
  };

  const setContributionSelection = ({ name, value }) => {
    resetContribution();
    switch (name) {
      case "contribution3":
        setContribution3(value);
        break;
      case "contribution4":
        setContribution4(value);
        break;
      case "contribution6":
        setContribution6(value);
        break;
      case "contribution8":
        setContribution8(value);
        break;
      case "contribution10":
        setContribution10(value);
        break;
      default:
        break;
    }
  };

  const setSignatureData = (data) => setSignature(data);

  const setDateData = ({ name, value }) => {
    switch (name) {
      case "day1":
        setDay1(value);
        break;
      case "day2":
        setDay2(value);
        break;
      case "month1":
        setMonth1(value);
        break;
      case "month2":
        setMonth2(value);
        break;
      case "year3":
        setYear3(value);
        break;
      case "year4":
        setYear4(value);
        break;
      default:
        break;
    }
  };

  const resetForm = () => {
    setKiwiSaverMember("");
    setSavingSuspension("");
    setIRDs(new Array(9).fill(""));
    setNameTitleOther(new Array(6).fill(""));
    setSelectedTitle("");
    setFirstName(new Array(NO_OF_NAME_COLUMN).fill(""));
    setSurname(new Array(NO_OF_NAME_COLUMN).fill(""));
    setStreetNumber(new Array(NO_OF_STREET_NUMBER_COLUMN).fill(""));
    setStreetAddress(new Array(NO_OF_STREET_ADDRESS_COLUMN).fill(""));
    setSubUrb(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
    setTown(new Array(NO_OF_SUBURB_COLUMNS).fill(""));
    setPostCode(new Array(NO_OF_POST_CODE_COLUMNS).fill(""));
    setDay(new Array(NO_OF_PHONE_NO_COLUMNS).fill("")); //Note: Here we are using day variable to be align with KS2 Pdf text.
    setMobile(new Array(NO_OF_MOBILE_NO_COLUMNS).fill(""));
    setEmail(new Array(NO_OF_EMAIL_COLUMNS).fill(""));
    setContribution3("");
    setContribution4("");
    setContribution6("");
    setContribution8("");
    setContribution10("");
    setDay1("");
    setDay2("");
    setMonth1("");
    setMonth2("");
    setYear3("");
    setYear4("");
    setSignature("");
  };

  const validateForm = (formData) => {
    const isRequiredFieldsFilled =
      (formData.kivimember_yes || formData.kivimember_no) &&
      formData.firstName &&
      formData.surName &&
      formData.IRDNumber;

    const isSignatureAndDateValid = formData.day && formData.month && formData.year && formData.signatureContent;

    const isRequiredContribution =
      formData.contribution3 ||
      formData.contribution4 ||
      formData.contribution6 ||
      formData.contribution8 ||
      formData.contribution10;

    if (isRequiredFieldsFilled && isRequiredContribution && isSignatureAndDateValid) {
      const isDateValid = validateDate(formData.day, formData.month, formData.year);
      if (!isDateValid) {
        return { isValid: false, message: "Signature date is invalid. Enter date in DD/MM/YY format e.g. 27/10/25" };
      }
      return { isValid: true };
    }
    return {
      isValid: false,
      message:
        "All mandatory fields must be completed: KiwiSaver Member, First Name, Surname, IRD Number, Contribution rate, Signature and Date.",
    };
  };

  const findSelectedTitle = (title) => {
    return title === selectedTitle ? "-" : "";
  };

  const submitForm = () => {
    const nameString = concateString(firstName);
    const surnameString = concateString(surname);
    const streetNumberString = concateString(streetNumber);
    const streetAddressString = concateString(streetAddress);
    const subUrbString = concateString(subUrb);
    const townString = concateString(town);
    const postCodeString = concateString(postCode);
    const emailString = concateString(email);

    const data = {
      interactiveDocument: "KS2",
      kivimember_yes: kiwiSaverMember === "yes" ? "-" : "",
      kivimember_no: kiwiSaverMember === "no" ? "-" : "",
      suspensionSaving_yes: savingSuspension === "yes" ? "-" : "",
      suspensionSaving_no: savingSuspension === "no" ? "-" : "",
      IRDNumber: iRDs.join(""),
      Mr: findSelectedTitle("Mr"),
      Ms: findSelectedTitle("Ms"),
      Mrs: findSelectedTitle("Mrs"),
      Miss: findSelectedTitle("Miss"),
      Other: findSelectedTitle("Other"),
      nameTitle: nameTitleOther.join(""),
      firstName: nameString,
      surName: surnameString,
      streetNumber: streetNumberString,
      streetAddress: streetAddressString,
      subUrb: subUrbString,
      town: townString,
      postCode: postCodeString,
      telephone3: day.slice(5).join(""),
      telephone1: day.slice(0, 2).join(""),
      telephone2: day.slice(2, 5).join(""),
      mobile1: mobile.slice(0, 3).join(""),
      mobile2: mobile.slice(3, 6).join(""),
      mobile3: mobile.slice(6).join(""),
      email1: emailString.substring(0, 31),
      email2: emailString.substring(31),
      day: day1 + day2,
      month: month1 + month2,
      year: year3 + year4,
      contribution3,
      contribution4,
      contribution6,
      contribution8,
      contribution10,
      signatureContent: signature,
    };

    const { isValid, message } = validateForm(data);

    if (isValid) {
      props.submit(data).then((result) => {
        if (result) {
          props.redirectToList();
        }
      });
    } else {
      popError([
        {
          type: "warning",
          title: "Warning",
          message: message || "Please fill all required fields.",
        },
      ]);
    }
  };

  return (
    <div className="ks-2-form">
      <KS2Header />
      <div className="col-sm-12">
        <div className="tcd-form-details">
          <KS2Intro />
          <form>
            <KS2SeactionAHeader />
            <KS2SectionAKiwiSaver setKiviMember={setKiwiSaverMemberOption} clearOther={clearOther} />
            <KS2SectionASuspensionSaving
              kiviMemberNo={kiwiSaverMember}
              setSavingSuspensionData={setSavingSuspensionOption}
              clearOther={clearOther}
            />
            <KS2SectionAAlertInfo />
            <KS2IRDNumber IRD={iRDs} setIRDData={setIRDData} />
            <KS2NameSalutation
              setSalutation={setSelectedTitleData}
              setNameTitleOtherData={setNameTitleOtherData}
              clearOther={clearOther}
              nameTitleOther={nameTitleOther}
            />
            <KS2Name
              count={NO_OF_NAME_COLUMN}
              keyName={"firstName"}
              name={firstName}
              setName={setName}
              disableAfterCount={NO_OF_NAME_COLUMN}
              smallTitleLabel={"First names"}
            />
            <KS2Name
              count={NO_OF_NAME_COLUMN}
              keyName={"surname"}
              name={surname}
              setName={setName}
              disableAfterCount={30}
              smallTitleLabel={"Surname"}
            />
            <KS2Address
              streetNumber={streetNumber}
              streetAddress={streetAddress}
              subUrb={subUrb}
              town={town}
              postCode={postCode}
              setAddressData={setAdrress}
            />
            <KS2ContactInfo day={day} mobile={mobile} setContactNumber={setContactNumber} />
            <KS2Email email={email} setEmail={setEmailData} />
            <KS2Contributions
              contribution3={contribution3}
              contribution4={contribution4}
              contribution6={contribution6}
              contribution8={contribution8}
              contribution10={contribution10}
              setContributionSelection={setContributionSelection}
            />
            <KS2Sign
              setDateData={setDateData}
              setSignatureData={setSignatureData}
              day1={day1}
              day2={day2}
              month1={month1}
              month2={month2}
              year3={year3}
              year4={year4}
              signature={signature}
            />
            <div className="row">
              <div className="reset-form-btn text-right pr-4">
                <Button type="reset" onClick={resetForm}>
                  RESET FORM
                </Button>
                &nbsp;&nbsp;
                <Button type="button" onClick={submitForm}>
                  SUBMIT FORM
                </Button>
              </div>
            </div>
          </form>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 section-box">
              <div className="kr-title">
                <div className="form-check disabled">
                  <label className="form-check-label pl-3 pr-4">Please give this completed form to your employer</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pagebreak" />
      <KS2Footer />
    </div>
  );
};

KS2.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default KS2;
